import { styled } from '@mui/material/styles'
import { Button, Box, Typography, FormControl } from '@mui/material'

export const DialogInner = styled(Box)({
  padding: '24px',
  width: '580px',
  textAlign: 'center',
})

export const DialogTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '40px',
  marginBottom: '16px',
})

export const DialogContent = styled(Box)({
  marginBottom: '24px',
})

export const FormControls = styled(FormControl)({
  width: '320px',
})

export const CancelButton = styled(Button)({
  background: '#F7F7F7',
  border: '1px solid #D4D4D4',
  color: '#222',
  fontSize: '15px',
  marginRight: '16px',
  boxShadow:
    '0px 1px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 1px 0px rgb(0 0 0 / 12%)',
  width: '112px',
})

export const SaveButton = styled(Button)({
  fontSize: '15px',
  width: '101px',
  height: '42px',
})
